export default __webpack_public_path__ + "static/media/calendar_blue.18adadb4.svg";